import { CustomDomainInterceptor } from '@microsec/interceptors';
import { KeycloakInterceptor } from '@microsec/interceptors';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideKeycloakAngular } from './keycloak.config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, ContextMenuService, MessageService } from 'primeng/api';
import { getServiceReplacements } from '@ids-services';
import { KeycloakAuthenticationService } from '@microsec/services';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import Aura from '@primeng/themes/aura';

export function createServiceReplacement(realSrv: any, mockSrv: any, shouldUseMockData = false) {
  return {
    provide: realSrv,
    useClass: !!environment.useMockData || !!shouldUseMockData ? mockSrv : realSrv,
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    // NGRX
    importProvidersFrom(
      StoreModule.forRoot(
        { router: routerReducer },
        {
          runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: false,
          },
        },
      ),
      StoreRouterConnectingModule.forRoot(),
      StoreDevtoolsModule.instrument(),
      EffectsModule.forRoot([]),
    ),
    // Keycloak
    KeycloakAuthenticationService,
    provideKeycloakAngular(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomDomainInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakInterceptor,
      multi: true,
    },
    // PrimeNG
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    // Services
    DialogService,
    DynamicDialogRef,
    DynamicDialogConfig,
    MessageService,
    ConfirmationService,
    ContextMenuService,
    // Service replacements
    [...getServiceReplacements(environment)],
  ],
};
